import { createContext } from "react";
import { AuthConfig } from "./config/authConfig";
import { keycloak, logout as oidcLogout } from "../auth/oidc";

export const getToken = async (): Promise<string | null> => {
  if (!keycloak.authenticated) return null;
  try {
    await keycloak.updateToken(30);
  } catch {
    keycloak.login();
    return null;
  }
  return keycloak.token ?? null;
};

export const isLoggedIn = (): boolean => !!keycloak.authenticated;

export const logOut = (): void => {
  AuthConfig.setUserInfo(null);
  AuthConfig.setMyInfo(null);
  void oidcLogout();
};

export const UserContext = createContext({
  isLoggedIn: isLoggedIn,
  logOut: logOut,
});
